import { ChevronLeft, SquarePen } from "lucide-react";
import { useTranslate } from "ra-core";

import type { AskClaude } from "./useAskClaude";

// Modellen edge-funksjonen bruker (MODEL i
// supabase/functions/ask_claude/agent.ts). Vises under tittelen, som i
// Raycast Quick AI, så det er tydelig hvem som svarer.
export const ASK_MODEL_LABEL = "Claude Haiku 5.5";

// Topplinjen i chatten: tilbake til søk, samtalens tittel og modell, og
// «Ny samtale».
export const AskHeader = ({
  ask,
  onBack,
}: {
  ask: AskClaude;
  onBack: () => void;
}) => {
  const translate = useTranslate();
  const first = ask.messages.find((m) => m.role === "user")?.content;
  const title =
    first ?? translate("crm.command.ask.new_chat", { _: "Ny samtale" });

  return (
    <div className="flex h-14 shrink-0 items-center gap-1 border-b border-border/60 px-2">
      <button
        type="button"
        onClick={onBack}
        aria-label={translate("crm.command.ask.back", {
          _: "Tilbake til søk",
        })}
        className="grid size-9 shrink-0 place-items-center rounded-lg text-muted-foreground transition-colors hover:bg-accent hover:text-foreground"
      >
        <ChevronLeft className="size-5" />
      </button>
      <div className="min-w-0 flex-1 px-1">
        <p className="truncate text-sm font-semibold leading-5">{title}</p>
        <p className="truncate text-xs leading-4 text-muted-foreground">
          {ask.context
            ? `${translate("crm.command.ask.about", {
                name: ask.context.name,
                _: "Om %{name}",
              })} · ${ASK_MODEL_LABEL}`
            : ASK_MODEL_LABEL}
        </p>
      </div>
      <button
        type="button"
        onClick={ask.reset}
        disabled={ask.messages.length === 0}
        aria-label={translate("crm.command.ask.new", { _: "Ny samtale" })}
        title={translate("crm.command.ask.new", { _: "Ny samtale" })}
        className="grid size-9 shrink-0 place-items-center rounded-lg text-muted-foreground transition-colors hover:bg-accent hover:text-foreground disabled:pointer-events-none disabled:opacity-40"
      >
        <SquarePen className="size-4" />
      </button>
    </div>
  );
};
